module.exports = __webpack_public_path__ + "img/s3_2.49aa6c9c.png";